module.exports = __webpack_public_path__ + "static/media/henrickHudson.2dc1c3b9.png";